/* 🤖 this file was generated by svg-to-ts */
export const matIconKitchen: {
  name: 'kitchen';
  data: string;
} = {
  name: 'kitchen',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M8 5h2v3H8zm0 7h2v5H8zm10-9.99L6 2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5z"/></svg>`
};
